import { PointsDistribution } from "../../PointsDistribution";

export type StaticCupModePoints = PointsDistribution;
export type DynamicCupModePoints = { [numLeft: string]: PointsDistribution };
export type CupModePoints = StaticCupModePoints | DynamicCupModePoints;

const isStaticCupModePoints = (
  points: CupModePoints
): points is StaticCupModePoints => {
  return (points as StaticCupModePoints).distribution !== undefined;
};

export const getPointsDistribution = (
  points: CupModePoints,
  numDrivers: number
): PointsDistribution | undefined => {
  if (isStaticCupModePoints(points)) {
    return points;
  }

  return points[numDrivers.toString()];
};
